import { LAYOUT_MARGIN } from '@experiment-management-shared/constants';
import { PanelLayoutItem } from '@experiment-management-shared/types';

export const calculatePanelPosition = (
  layout: PanelLayoutItem,
  gridW: number,
  gridH: number,
  margin = LAYOUT_MARGIN
) => {
  if (!layout) {
    return {
      topLeft: { x: 0, y: 0 },
      bottomRight: { x: 0, y: 0 }
    };
  }
  const { x, y, w, h } = layout;

  const topLeftX = x * (gridW + margin);
  const topLeftY = y * (gridH + margin);

  const bottomRightX = (x + w) * (gridW + margin) - margin;
  const bottomRightY = (y + h) * (gridH + margin) - margin;

  return {
    topLeft: { x: topLeftX, y: topLeftY },
    bottomRight: { x: bottomRightX, y: bottomRightY }
  };
};
